module.exports = __webpack_public_path__ + "assets/img/ConditionBAPC.adbaccef.png";